import './vendor/bootstrap/css/bootstrap.min.css';
import './vendor/font-awesome/css/font-awesome.min.css';
import './vendor/simple-line-icons/css/simple-line-icons.css';
import './device-mockups/device-mockups.min.css';
import './css/new-age.css';

import React, { Component } from 'react';
import Scroll from 'react-scroll';

import {
  Button,
  ButtonGroup,
  Card,
  Col,
  Collapse,
  Container,
  Jumbotron,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  Row,
  UncontrolledAlert,
  UncontrolledCarousel,
} from 'reactstrap';

import HomeContainer from './components/HomeContainer';
import BroadcastAlert from './components/BroadcastAlert';
import BusinessAddress from './components/BusinessAddress';
import BusinessMap, { LOCATION_URL } from './components/BusinessMap';
import NewCustomerForm from './components/NewCustomerForm';
import Services from './components/Services';

import logo from './img/ecofresh-logo-landing.png';
import shoppes from './img/shoppes.jpg';
import shoppesFront from './img/shoppes-front.jpg';
import coupon from './img/coupons/first-time-offer.jpg';


const mapImgs = [
  {
    src: shoppes,
    captionText: "1"
  },
  {
    src: shoppesFront,
    captionText: "2"
  }
];

const duration = 300;

const defaultStyle = {
  transition: `opacity ${duration}ms ease-in-out`,
  opacity: 0,
}

const transitionStyles = {
  entering: { opacity: 1 },
  entered:  { opacity: 1 },
};

function isTouchDevice() {
  return 'ontouchstart' in window        // works on most browsers 
      || navigator.maxTouchPoints;       // works on IE10/11 and Surface
};

class Main extends Component {
  constructor(props) {
    super(props);

    this.state = {
      windowW: '0',
      windowH: '0',
      collapse: true,
      shrinkClass: "",
      modalForm: false,
      modalMap: false,
      popoverOpen: false,
      showingInfoWindow: false,
      activeMarker: {},
      selectedPlace: {},
    };

    this.scrollOptions = {
      containerId: "containerElementID",
      activeClass: "active",
      spy: true,
      smooth: "easeInOutQuint",
      offset: -47.5,
      duration: 1000,
      isDynamic: true
    };
  }

  handleScroll = (event) => {
    if (window.scrollY > 100) {
      this.setState({ shrinkClass: " navbar-shrink" });
    } else {
      this.setState({ shrinkClass: "" });
    }
  };

  showInfoWindow = (props, marker, e) => {
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true
    });
  };
 
  hideInfoWindow = (props) => {
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null
      })
    }
  };

  openDirectionsWindow = () => {
    window.open(LOCATION_URL, '_blank');
  };

  scrollToTop = (options) => {
    Scroll.animateScroll.scrollToTop(options);
    if (!this.state.collapse) this.toggle();
  };

  scrollToBottom = (options) => {
    Scroll.animateScroll.scrollToTop(options);
    if (!this.state.collapse) this.toggle();
  };

  scrollToSection = () => {
    // Closes responsive menu when a scroll trigger link is clicked
    if (!this.state.collapse) this.toggle();
  };

  toggle = () => {
    const status = !this.state.collapse ? 'Opening...' : 'Closing...';
    this.setState({ collapse: !this.state.collapse, status });
  };

  toggleModalForm = () => {
    this.setState({ modalForm: !this.state.modalForm }, () => {
      //this.refNavbar.style = (this.state.modalForm) ? {paddingRight: 17} : {paddingRight: 0};
      //document.body.style = (this.state.modalForm) ? {overflowY: "hidden", position: "fixed"} : undefined;
    });
  };

  toggleModalMap = () => {
    this.setState({ modalMap: !this.state.modalMap });
  };

  togglePopover = () => {
    this.setState({
      popoverOpen: !this.state.popoverOpen
    });
  };

  onMouseoverMarker = (e) => {
    console.log(e);
  };

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    Scroll.scrollSpy.update();
  }

  componentWillMount() {
    // document.body.style = {overflowY: "scroll !important"};
  }

  componentWillUnmount() {
    // document.body.style = undefined;
    window.removeEventListener('scroll', this.handleScroll);
  }

  render() {
    return (
      <div className="Main">

        {/*<!-- Navigation -->*/}
        <Navbar light fixed="top" expand="lg" className={this.state.shrinkClass} id="mainNav">
          <Container>
            <NavbarBrand onClick={() => this.scrollToTop(this.scrollOptions)} className="eco-logo" style={{cursor: "pointer"}} />
            <NavbarToggler onClick={this.toggle} type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded={!this.state.collapse} aria-label="Toggle navigation" style={{"fontFamily": "inherit"}}>
              Menu&nbsp;
              <i className="fa fa-bars"></i>
            </NavbarToggler>
            <Collapse navbar isOpen={!this.state.collapse} id="navbarResponsive">
              <Nav navbar className="ml-auto">
                <NavItem>
                  <Scroll.Link to="scroll-download" onClick={() => this.scrollToSection()} activeClass={this.scrollOptions.activeClass} spy={this.scrollOptions.spy} smooth={this.scrollOptions.smooth} offset={this.scrollOptions.offset} duration={this.scrollOptions.duration} isDynamic={this.scrollOptions.isDynamic} className="nav-link" style={{cursor: "pointer"}}>About Us</Scroll.Link>
                </NavItem>
                <NavItem>
                  <Scroll.Link to="scroll-features" onClick={() => this.scrollToSection()} activeClass={this.scrollOptions.activeClass} spy={this.scrollOptions.spy} smooth={this.scrollOptions.smooth} offset={this.scrollOptions.offset} duration={this.scrollOptions.duration} isDynamic={this.scrollOptions.isDynamic} className="nav-link" style={{cursor: "pointer"}}>Services</Scroll.Link>
                </NavItem>
                <NavItem>
                  <Scroll.Link to="scroll-contact" onClick={() => this.scrollToSection()} activeClass={this.scrollOptions.activeClass} spy={this.scrollOptions.spy} smooth={this.scrollOptions.smooth} offset={this.scrollOptions.offset} duration={this.scrollOptions.duration} isDynamic={this.scrollOptions.isDynamic} className="nav-link" style={{cursor: "pointer"}}>Contact Us</Scroll.Link>
                </NavItem>
              </Nav>
            </Collapse>
          </Container>
        </Navbar>

        <header className="masthead">
          <Container className="h-100">
            <Row className="h-100">
              <Col xs={12} lg={7} className="my-auto">
                <div className="header-content mx-auto">
                    <div className="d-inline-block">
                      <img src={logo} alt="ecofresh cleaners" className="img-fluid" />
                      <h1 className="mt-2 display-4">Cleaners</h1>
                    </div>
                  <Container className='mt-3 mb-3'>
                    <div className="d-inline-block">
                      <Row>
                        <strong>
                          Eco-Friendly Dry Cleaning
                        </strong>
                      </Row>
                      <Row>
                        <ul className='mt-3 mb-3'>
                          <li>
                            Shirts Laundered on Premises
                          </li>
                          <li>
                            Tailoring and Alterations
                          </li>
                          <li>
                            Leather and Suede Cleaning
                          </li>
                          <li>
                            ...and much more!
                          </li>
                        </ul>
                      </Row>
                      <Row>
                        <Card body inverse className='mt-2 mb-2' style={{backgroundColor: "rgba(0, 0, 0, 0.1)", borderColor: "#ffffff", color: 'black', maxWidth: "350px"}}>
                          <BusinessAddress addressClass='mb-3' hideName={true} />
                          <Scroll.Link
                            to="scroll-contact"
                            onClick={() => this.scrollToSection()}
                            activeClass={this.scrollOptions.activeClass}
                            spy={this.scrollOptions.spy}
                            smooth={this.scrollOptions.smooth}
                            offset={this.scrollOptions.offset}
                            duration={this.scrollOptions.duration}
                            isDynamic={this.scrollOptions.isDynamic}
                            className="btn btn-success btn-sm"
                            style={{cursor: "pointer", textTransform: "none"}}
                          >
                            New customer? Click here!
                          </Scroll.Link>
                        </Card>
                      </Row>
                    </div>
                  </Container>
                  <ButtonGroup style={{cursor: "pointer"}}>
                    <Scroll.Link
                      to="scroll-features"
                      onClick={() => this.scrollToSection()}
                      activeClass={this.scrollOptions.activeClass}
                      spy={this.scrollOptions.spy}
                      smooth={this.scrollOptions.smooth}
                      offset={this.scrollOptions.offset}
                      duration={this.scrollOptions.duration}
                      isDynamic={this.scrollOptions.isDynamic}
                      className="btn btn-outline btn-xl"
                    >
                      Services
                    </Scroll.Link>
                    <div className="btn btn-outline btn-xl" onClick={this.toggleModalMap}>Come visit us!</div>
                  </ButtonGroup>

                  <Modal isOpen={this.state.modalForm} toggle={this.toggleModalForm} size="lg" backdrop="static">
                    <ModalHeader toggle={this.toggleModalForm}>New Customer Form</ModalHeader>
                    <ModalBody>
                      {isTouchDevice() ? (
                        <UncontrolledAlert color="info">
                          Note: If you're having trouble scrolling on a touch screen device, try scrolling outside of the input fields.
                        </UncontrolledAlert>
                      ) : null}
                      <Container className='mt-5 mb-5' style={{maxWidth: '600px'}}>
                        <NewCustomerForm onSuccess={this.toggleModalForm} />
                      </Container>

                    </ModalBody>
                    <ModalFooter>
                      <Button color="primary" onClick={this.toggleModalForm}>Close</Button>
                    </ModalFooter>
                  </Modal>

                  <Modal isOpen={this.state.modalMap} toggle={this.toggleModalMap} size="lg" backdrop="static">
                    <ModalHeader toggle={this.toggleModalMap}>Location</ModalHeader>
                    <ModalBody style={{height: "400px", marginBottom: "15px", marginRight: "0px"}}>

                      <BusinessMap />

                    </ModalBody>
                    <ModalFooter>
                      <Button color="info" onClick={this.openDirectionsWindow}>Get Directions</Button>
                      <Button color="primary" onClick={this.toggleModalMap}>Close</Button>
                    </ModalFooter>
                  </Modal>
                </div>
              </Col>
              <Col xs={12} lg={5} className="my-auto">
                <Container>
                  <div style={{"maxWidth": "325px", "marginRight": "auto", "marginLeft": "auto"}}>
                    <HomeContainer />
                  </div>
                </Container>
              </Col>
            </Row>
          </Container>
        </header>

        <Scroll.Element name="scroll-download" className="element">
          <section className="download bg-primary text-center" id="download">
              <Container>
                  <Row>
                    <Col md={8} className="mx-auto">
                      <h2 className="section-heading mb-5">About Us</h2>
                      <div className="d-none d-sm-block" style={{width: "400px", margin: "0 auto"}}>
                        <UncontrolledCarousel items={mapImgs} indicators={false} captionText=''/>
                      </div>
                      <div className="mt-5">
                        <p>
                          As a family owned business, with over 28 years of personal experience, we have built a reputation of excellence in the fabric care industry. We look forward to sharing our knowledge and craftsmanship with you. Our goal is keeping you and your wardrobe looking its best day after day. If you should have any questions regarding our services, please call.
                        </p>
                        <p>  
                          Quality is the main concern at Ecofresh Cleaners and special attention is given to each individual garment, insuring the customer's satisfaction and expectations. There's nothing more annoying than being late for that important business meeting, only to find that the cleaners did not sew on that collar button they busted. We do our best to catch little things like missing buttons and ripped seams and fix those things at no additional charge to the customer.
                        </p>
                        <p className="lead mt-5">
                          It's the little things that make the difference.
                        </p>
                      </div>
                    </Col>
                  </Row>
              </Container>
          </section>
        </Scroll.Element>

        <Scroll.Element name="scroll-features" className="element">
          <section className="features" id="features">
            <Container className="text-center">
                <div className="section-heading">
                  <h2>Services</h2>
                </div>
                <hr />
                <Row className="mt-5 align-items-center">
                  <Col xs={12} lg={6}>
                    <Jumbotron>
                      <h2><small className="text-muted">Guaranteed<br />Plain and Simple</small></h2>
                      <p className="text-muted">You have to be 100% delighted with the quality of our work or we will reprocess the garment for free.</p>
                    </Jumbotron>
                  </Col>
                  <Col>
                    <Jumbotron>
                      <h2><small className="text-muted">Same Day Service</small></h2>
                      <p className="text-muted">In by 9:00 AM.<br />Out by 5:00 PM.</p>
                    </Jumbotron>
                  </Col>
                </Row>
                <hr />
                <Row>
                  <Col className="my-auto">
                    <Container>
                      <Services />
                    </Container>
                  </Col>
                </Row>
            </Container>
          </section>
         </Scroll.Element>

        <Scroll.Element name="scroll-contact" className="element">
          <section className="cta">
            <div className="cta-content">
                <Container>
                    <Row>
                      <Col>
                        <h3>Contact Us</h3>
                        <div style={{color: "#FFFFFF"}}>
                          <BusinessAddress addressClass='mt-5 mb-5' />
                          <div className="btn btn-outline btn-xl" onClick={this.toggleModalForm} style={{cursor: "pointer"}}>New Customer Form</div>
                        </div>
                      </Col>
                      <Col className="d-none d-lg-block">
                        <BusinessMap style={{
                          opacity: 0.75,
                          transition: 'opacity .5s',
                          ':hover': {
                            opacity: 1
                          }
                        }}/>
                      </Col>
                    </Row>
                    
                </Container>
            </div>
            <div className="overlay"></div>
          </section>
               
          <section className="contact bg-primary" id="contact">
            <Container>
              <h2>Coupons</h2>
              <Container className="mt-5 mb-5">
                <Row>
                  <Col>
                    <img src={coupon} alt="coupon" className="img-fluid" />
                  </Col>
                </Row>
              </Container>
            </Container>
          </section>
        </Scroll.Element>

        <footer>
          <Container>
            <p>&copy; {(new Date()).getFullYear() + ' '} Ecofresh Cleaners. All Rights Reserved.</p>
            <p><small>Hanger icon made by <a href="http://www.freepik.com" title="Freepik">Freepik</a> from <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a> is licensed by <a href="http://creativecommons.org/licenses/by/3.0/" title="Creative Commons BY 3.0">CC 3.0 BY</a></small></p>
          </Container>
        </footer>

        <BroadcastAlert />
      </div>
    );
  }
}

export default Main;

// export default GoogleApiWrapper({
//   apiKey: ("AIzaSyDu8gozjUde_llcKGWn1odY_78QJ4VyShE"),
//   version: '3'
// })(Main)


// WEBPACK FOOTER //
// ./src/Main.js